// extracted by mini-css-extract-plugin
export default {"PersonIllustration":"SupportDetails_PersonIllustration__tPp1f","SupportDetails":"SupportDetails_SupportDetails__RV6gh"};